module.exports = __webpack_public_path__ + "mainassets/img/arrow-left-404.19559523.svg";